import { IOfferScopeStatusLang } from '../../../types/lang'
import { EOfferScopeStatus } from '../../../types'

export const offerScopeStatusLang: IOfferScopeStatusLang = {
	offer_scope_status: {
		[EOfferScopeStatus.none]: 'none_ua',
		[EOfferScopeStatus.active]: 'active_ua',
		[EOfferScopeStatus.paused]: 'paused_ua',
		[EOfferScopeStatus.closed]: 'closed_ua',
	}
}